<wk-icon-spinner-sprite-pds3 />
<wk-icon-filled-caution-sprite-pds3 />
<wk-icon-user2-sprite-pds3 />
<wk-icon-filled-flag-sprite-pds3 />
<wk-icon-book-open-sprite-pds3 />
<wk-icon-lock-sprite-pds3 />
<wk-icon-lock-open-sprite-pds3 />
<wk-icon-chevron-double-left-sprite-pds3 />
<wk-icon-chevron-double-right-sprite-pds3 />
<router-outlet />

@if (!sessionInitialized && !showNavigationDenied && !showNavigationUnauthorized) {
    <app-loader [text]="isFromSettingsPage ? '' : ('General.LoadingEnvironment' | translate)" size="medium" />
} @else if (showNavigationDenied) {
    <div class="wk-backdrop wk-backdrop--zindex-100000">
        <div class="wk-modal wk-modal--width-600 wk-modal--font-family-fira-sans">
            <div
                class="wk-modal__header--info wk-modal__header--info-line-height-26 wk-modal__header--info-font-weight-400 wk-modal__header--info-align-items-center wk-modal__header--info-height-41"
            >
                <div class="wk-modal__header--title wk-modal__header--title-font-size-20">{{ "General.AccessDeniedTitle" | translate }}</div>
                <div class="wk-modal__header--x" (click)="showNavigationDenied = false">
                    <span class="fa fa-times"></span>
                </div>
            </div>
            <div class="wk-modal__body wk-modal__body--font-size-16">
                <div class="wk-modal__body--line-height-24">{{ "General.AccessDenied1" | translate }} {{ "General.AccessDenied2" | translate }}</div>
                <div class="wk-modal__buttons-section wk-modal__buttons-section--justify-content-flex-end">
                    <button class="btn-primary" (click)="showNavigationDenied = false">Ok</button>
                </div>
            </div>
        </div>
    </div>
}

<notify-popup />
